var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgendaWrapper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2018_1679)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -2,
    y: -4,
    width: 90,
    height: 92
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1px)",
      clipPath: "url(#bgblur_1_2018_1679_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2018_1679)",
    "data-figma-bg-blur-radius": 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    r: 43,
    fill: "url(#paint0_radial_2018_1679)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    r: 41.5,
    stroke: "url(#paint1_linear_2018_1679)",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5781 49L20.7891 37.7266H21.8516L26.0703 49H24.9453L23.6953 45.5469H18.9531L17.7031 49H16.5781ZM21.2734 39.125L19.2812 44.625H23.3594L21.3672 39.125H21.2734ZM30.9375 51.9375C29.0078 51.9375 27.7266 51.0781 27.5078 49.7734L27.5156 49.7656H28.5859L28.5938 49.7734C28.7812 50.5078 29.6562 51.0156 30.9375 51.0156C32.5625 51.0156 33.5703 50.1875 33.5703 48.8281V46.9453H33.4688C32.9688 48.0547 31.9375 48.6953 30.6484 48.6953C28.4844 48.6953 27.1016 47 27.1016 44.5859V44.5703C27.1016 42.1641 28.4922 40.4453 30.6641 40.4453C31.9609 40.4453 33 41.1641 33.4844 42.2891H33.5547V40.5859H34.5938V48.8984C34.5938 50.7344 33.1484 51.9375 30.9375 51.9375ZM30.8516 47.7734C32.5391 47.7734 33.5859 46.4844 33.5859 44.6016V44.5859C33.5859 42.7031 32.5156 41.3672 30.8516 41.3672C29.1719 41.3672 28.1562 42.6875 28.1562 44.5703V44.5859C28.1562 46.4688 29.1719 47.7734 30.8516 47.7734ZM40.6172 49.1406C38.2578 49.1406 36.8047 47.4609 36.8047 44.8203V44.8047C36.8047 42.1797 38.2734 40.4453 40.5312 40.4453C42.7891 40.4453 44.1797 42.1328 44.1797 44.625V45.0625H37.8594C37.8906 47.0312 38.9688 48.2109 40.6406 48.2109C41.8672 48.2109 42.7109 47.6328 42.9844 46.9766L43.0156 46.9219H44.0547L44.0312 46.9844C43.7031 48.125 42.4766 49.1406 40.6172 49.1406ZM40.5312 41.3672C39.0781 41.3672 38 42.3984 37.8672 44.2188H43.1328C43.0156 42.3516 41.9766 41.3672 40.5312 41.3672ZM46.3984 49V40.5859H47.4297V42.0625H47.5312C47.9766 41.0469 48.8828 40.4453 50.1953 40.4453C52.0703 40.4453 53.1406 41.5703 53.1406 43.5312V49H52.1094V43.7891C52.1094 42.1875 51.3828 41.3672 49.9219 41.3672C48.4375 41.3672 47.4297 42.4141 47.4297 44V49H46.3984ZM58.8438 49.1406C56.7188 49.1406 55.2891 47.3984 55.2891 44.8047V44.7891C55.2891 42.1797 56.7109 40.4453 58.8438 40.4453C60.1172 40.4453 61.2031 41.1406 61.6719 42.2266H61.7656V37.2344H62.8047V49H61.7656V47.3203H61.6719C61.1797 48.4531 60.1406 49.1406 58.8438 49.1406ZM59.0625 48.2188C60.7188 48.2188 61.7891 46.875 61.7891 44.7969V44.7812C61.7891 42.7109 60.7188 41.3672 59.0625 41.3672C57.3984 41.3672 56.3438 42.7031 56.3438 44.7812V44.7969C56.3438 46.8828 57.3984 48.2188 59.0625 48.2188ZM67.8438 49.1406C66.2188 49.1406 65.0312 48.1797 65.0312 46.6797V46.6641C65.0312 45.2031 66.1172 44.3516 68.0625 44.2188L70.6875 44.0469V43.2578C70.6875 42.0234 69.9375 41.3672 68.5781 41.3672C67.4375 41.3672 66.6328 41.8281 66.4141 42.6641L66.4062 42.6797H65.3672L65.375 42.6484C65.5938 41.3047 66.8672 40.4453 68.6094 40.4453C70.5781 40.4453 71.7266 41.4766 71.7266 43.25V49H70.6875V47.5547H70.5938C70.0938 48.5547 69.0859 49.1406 67.8438 49.1406ZM66.0859 46.6641C66.0859 47.625 66.9062 48.2344 68.0391 48.2344C69.5469 48.2344 70.6875 47.2031 70.6875 45.8672V44.8906L68.2031 45.0625C66.7734 45.1562 66.0859 45.6953 66.0859 46.6484V46.6641Z",
    fill: "url(#paint2_linear_2018_1679)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2018_1679",
    x: -2,
    y: -4,
    width: 90,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2018_1679"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_2018_1679_clip_path",
    transform: "translate(2 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    r: 43
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2018_1679",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43 43) rotate(90) scale(43)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807692,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2018_1679",
    x1: 84.0493,
    y1: -0.0000057811,
    x2: -14.0817,
    y2: 21.3862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D52E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0F6AE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076CE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2018_1679",
    x1: 44.5,
    y1: 30,
    x2: 44.5,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00063E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030D6C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2018_1679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    rx: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgendaWrapper);
export default __webpack_public_path__ + "static/media/agenda-wrapper.519257576a965bd4026e7cf5cc4782ce.svg";
export { ForwardRef as ReactComponent };